<template>
  <form :class="$style.wrap" @submit.prevent="onSubmit">
    <!-- 角色 id -->
    <div :class="$style.field">
      <input
        v-model="roleId.value"
        type="tel"
        :placeholder="`请输入${roleId.label}`"
        :maxlength="roleId.maxLength"
        :class="$style['field-input']"
      />
    </div>
    <!-- 验证码 -->
    <div :class="$style.field" style="display: flex; align-items: center">
      <input
        v-model="verifyCode.value"
        type="tel"
        :placeholder="`请输入${verifyCode.label}`"
        :maxlength="verifyCode.maxLength"
        :class="$style['field-input']"
        style="width: 4.3rem"
      />
      <!-- 发送验证码按钮 -->
      <verify-code-sender
        :role-id="roleId.value"
        :pattern="roleId.pattern"
        :class="$style['btn-code']"
      />
    </div>
    <!-- 表单提交按钮 -->
    <button :class="[$style['btn-submit']]" />
    <!-- 帮助信息 -->
    <ul :class="$style.tip">
      <li><em v-html="roleId.tip" /></li>
      <li><em v-html="verifyCode.tip" /></li>
    </ul>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { login, fetchSigninInfo, fetchTeamInfo } from '@/api'
import VerifyCodeSender from './VerifyCodeSender'
import { getQueryString } from '@/utils'

export default {
  name: 'BindForm',
  components: { VerifyCodeSender },
  data() {
    return {
      // 角色 id
      roleId: {
        value: '',
        label: '您的团长ID',
        maxLength: 18,
        pattern: /^[1-9][0-9]{4,17}$/,
        tip: '- ID为一串数字，点击游戏内左上角头像打开角色信息面板即可查看'
      },
      // 验证码
      verifyCode: {
        value: '',
        label: '游戏邮件验证码',
        maxLength: 6,
        pattern: /^[0-9]{6}/,
        tip: '- 验证码会通过游戏内邮件发放，请登录游戏查看'
      }
    }
  },
  computed: {
    ...mapGetters(['isDebug'])
  },
  methods: {
    ...mapActions(['setToken', 'setUser', 'updateAppData', 'setSigninInfo', 'setTeamInfo']),
    validateForm() {
      const { roleId, verifyCode } = this

      // 验证角色 id 有效性
      if (!roleId.value) {
        return `请输入${roleId.label}`
      } else if (!roleId.pattern.test(roleId.value)) {
        return `请输入有效的${roleId.label}`
      }

      // 验证验证码有效性
      if (!verifyCode.value) {
        return `请输入${verifyCode.label}`
      } else if (!verifyCode.pattern.test(verifyCode.value)) {
        return `请输入有效的${verifyCode.label}`
      }

      return false
    },
    async onSubmit() {
      const validationError = this.validateForm()
      if (validationError) {
        this.$toast(validationError)
        return
      }
      const { roleId, verifyCode, $bl } = this
      try {
        const { data = {}, msg } = await login({
          role_id: roleId.value,
          mail_code: verifyCode.value
        })
        this.$toast(msg)
        if (Object.keys(data).length > 0 && data.auth_token) {
          const { auth_token, expires_in, bind_info = {} } = data
          // 存储 token
          this.setToken({
            token: auth_token,
            expire: `${expires_in}s`
          })
          // 更新数据
          if (Object.keys(bind_info).length > 0) {
            // 设置用户基本信息
            this.setUser(bind_info)
            // 设置活动相关数据
            this.updateAppData(bind_info)
            // 初始化签到信息
            this.initSignin()
            // 初始化队伍信息
            this.initTeam()
            // 绑定后回调
            this.$emit('bind-success')
            // 设置前端统计用户名
            if ($bl) {
              $bl.setConfig({
                setUsername: () => {
                  return String(roleId.value)
                }
              })
            }
          }
        }
      } catch (err) {
        //
      }
    },
    reset() {
      this.roleId.value = ''
      this.verifyCode.value = ''
    },
    async initSignin() {
      const { data = {} } = await fetchSigninInfo(
        this.isDebug && { test_time: getQueryString('t') }
      )
      if (Object.keys(data).length > 0) {
        this.setSigninInfo(data)
      }
    },
    async initTeam() {
      const { data = {} } = await fetchTeamInfo()
      this.setTeamInfo(data)
    }
  }
}
</script>

<style lang="less" module>
@input-width: 6.12rem;
@input-height: 0.95rem;

.wrap {
  width: @input-width;
  margin: 0.16rem auto 0;
}

/* 输入项 */
.field {
  .background-fill('./images/field-bg.png', 100% 100%);

  position: relative;
  height: @input-height;
  margin-bottom: 0.5rem;

  &-input {
    .size(100%);

    border: 0;
    padding-left: 0.65rem;
    background-color: transparent;
    color: #c43137;

    &::placeholder {
      color: fade(#c43137, 50%);
    }
  }
}

.btn {
  /* 发送验证码按钮 */
  &-code {
    .size(1.6rem, 0.54rem);
    .background-fill('./images/btn-code.png');

    font-size: 0.25rem;
    color: #c1893e;

    &[disabled] {
      opacity: 0.5;
      cursor: default;
    }
  }

  /* 表单提交按钮 */
  &-submit {
    .size(2.25rem, 0.66rem);
    .background-fill('./images/btn-bind.png');

    display: block;
    margin: 0.2rem auto 0;

    &[disabled] {
      opacity: 0.5;
      cursor: default;
    }
  }
}

/* 帮助信息 */
.tip {
  margin-top: 0.22rem;
  font-size: 0.2rem;
  line-height: 1.6;
  user-select: none;
}
</style>
